{
  "version": 1,
  "asset_id": "7239e626-5730-4e3e-9e20-721e24c9f96b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7239e626-5730-4e3e-9e20-721e24c9f96b/mark-128.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7239e626-5730-4e3e-9e20-721e24c9f96b/mark-128.avif",
  "original_filename": "mark-128.avif",
  "size": 4538,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:05Z"
}
